export default __webpack_public_path__ + "static/logo-43e174572a2969546e0335f5a9e1a7f7.png";